module.exports = __webpack_public_path__ + "img/systems-banner.7f638925.png";